

// import React, { useEffect, useState } from "react";
// import { useTranslation } from "react-i18next";
// import { useParams } from "react-router-dom";
// import "./DiscountPopup.scss";

// const DiscountPopup = () => {
//   const { t } = useTranslation();
//   const { lang } = useParams();

//   const [isOpen, setIsOpen] = useState(false);
//   const [submitted, setSubmitted] = useState(false);
//   const [email, setEmail] = useState("");

//   const languageKey = lang || "en";

//   // Show popup after delay if not seen
//   useEffect(() => {
//     const key = `discountPopupSeen-${languageKey}`;
//     const seen = localStorage.getItem(key);

//     if (!seen) {
//       const timer = setTimeout(() => setIsOpen(true), 1200);
//       return () => clearTimeout(timer);
//     }
//   }, [languageKey]);

//   // Reset popup when user switches language
//   useEffect(() => {
//     setSubmitted(false);
//     setIsOpen(false);
//     const key = `discountPopupSeen-${languageKey}`;
//     localStorage.removeItem(key);
//     const timer = setTimeout(() => setIsOpen(true), 800);
//     return () => clearTimeout(timer);
//   }, [languageKey]);

//   const closePopup = () => {
//     localStorage.setItem(`discountPopupSeen-${languageKey}`, "true");
//     setIsOpen(false);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!email) return;

//     try {
//       // 1. Submit form to Netlify Forms for record-keeping
//       const formData = new FormData();
//       formData.append("email", email);
//       formData.append("language", languageKey);
//       formData.append("consent", "yes");

//       await fetch("/", {
//         method: "POST",
//         body: formData,
//       });

//       // 2. Send discount email + copy to Gmail via Netlify function
//       await fetch("/.netlify/functions/send-discount", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ email }),
//       });

//       setSubmitted(true);
//       localStorage.setItem(`discountPopupSeen-${languageKey}`, "true");
//     } catch (err) {
//       console.error("Discount popup submit failed:", err);
//       alert(t("discountPopup.submitError") || "Something went wrong");
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="discount-popup">
//       <div className="discount-popup__backdrop" onClick={closePopup} />
//       <div className="discount-popup__card">
//         <button
//           className="discount-popup__close"
//           onClick={closePopup}
//           aria-label="Close popup"
//         >
//           ×
//         </button>

//         {!submitted ? (
//           <>
//             <h3 className="discount-popup__title">
//               {t("discountPopup.title")}
//             </h3>
//             <p className="discount-popup__text">{t("discountPopup.text")}</p>

//             <form
//               onSubmit={handleSubmit}
//               className="discount-popup__form"
//               netlify
//             >
//               <input
//                 type="email"
//                 name="email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 required
//                 placeholder={t("discountPopup.emailPlaceholder")}
//                 className="discount-popup__input"
//               />

//               <label className="discount-popup__consent">
//                 <input type="checkbox" name="consent" value="yes" required />
//                 {t("discountPopup.consent")}
//               </label>

//               <button type="submit" className="discount-popup__submit">
//                 {t("discountPopup.submit")}
//               </button>
//             </form>
//           </>
//         ) : (
//           <div className="discount-popup__success">
//             <h3>{t("discountPopup.successTitle")}</h3>
//             <p>{t("discountPopup.successText")}</p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default DiscountPopup;




import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import "./DiscountPopup.scss";

const DiscountPopup = () => {
  const { t } = useTranslation();
  const { lang } = useParams();

  const [isOpen, setIsOpen] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [email, setEmail] = useState("");

  const languageKey = lang || "en";

  // Show popup after delay if not seen
  useEffect(() => {
    const key = `discountPopupSeen-${languageKey}`;
    const seen = localStorage.getItem(key);

    if (!seen) {
      const timer = setTimeout(() => setIsOpen(true), 1200);
      return () => clearTimeout(timer);
    }
  }, [languageKey]);

  // Reset popup when language changes
  useEffect(() => {
    setSubmitted(false);
    setIsOpen(false);
    const key = `discountPopupSeen-${languageKey}`;
    localStorage.removeItem(key);

    const timer = setTimeout(() => setIsOpen(true), 800);
    return () => clearTimeout(timer);
  }, [languageKey]);

  const closePopup = () => {
    localStorage.setItem(`discountPopupSeen-${languageKey}`, "true");
    setIsOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    try {
      const formData = new FormData(e.target);

      await fetch("/", {
        method: "POST",
        body: formData,
      });

      setSubmitted(true);
      localStorage.setItem(`discountPopupSeen-${languageKey}`, "true");
    } catch (err) {
      console.error("Discount popup submit failed:", err);
      alert(t("discountPopup.submitError") || "Something went wrong");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="discount-popup">
      <div className="discount-popup__backdrop" onClick={closePopup} />

      <div className="discount-popup__card">
        <button
          className="discount-popup__close"
          onClick={closePopup}
          aria-label="Close popup"
        >
          ×
        </button>

        {!submitted ? (
          <>
            <h3 className="discount-popup__title">
              {t("discountPopup.title")}
            </h3>

            <p className="discount-popup__text">
              {t("discountPopup.text")}
            </p>

            <form
              name="discount"
              method="POST"
              data-netlify="true"
              onSubmit={handleSubmit}
              className="discount-popup__form"
            >
              {/* REQUIRED hidden input for Netlify */}
              <input type="hidden" name="form-name" value="discount" />

              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder={t("discountPopup.emailPlaceholder")}
                className="discount-popup__input"
              />

              <label className="discount-popup__consent">
                <input type="checkbox" name="consent" value="yes" required />
                {t("discountPopup.consent")}
              </label>

              <button type="submit" className="discount-popup__submit">
                {t("discountPopup.submit")}
              </button>
            </form>
          </>
        ) : (
          <div className="discount-popup__success">
            <h3>{t("discountPopup.successTitle")}</h3>
            <p>{t("discountPopup.successText")}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DiscountPopup;